import { indexedMap } from './indexedMap';
import { indexedSet } from './indexedSet';
export const createDirectedGraph = () => {
  // adjacency lists
  const outgoingEdges = indexedSet();
  const incomingEdges = indexedSet();

  // edge metadata
  const edgeMetadata = indexedMap();

  // nodes
  const nodes = new Map();

  // basic node operations
  const hasNode = id => nodes.has(id);
  const getNode = id => nodes.get(id);
  const setNode = (id, node) => {
    nodes.set(id, node);
  };

  // edge metadata
  const getEdgeMetadata = (sourceId, targetId) => edgeMetadata.get(sourceId, targetId);
  const setEdgeMetadata = (sourceId, targetId, metadata) => {
    edgeMetadata.set(sourceId, targetId, metadata);
  };

  // edge operations
  const hasEdge = (sourceId, targetId) => {
    var _outgoingEdges$get;
    return !!((_outgoingEdges$get = outgoingEdges.get(sourceId)) !== null && _outgoingEdges$get !== void 0 && _outgoingEdges$get.has(targetId));
  };
  function addEdge(sourceId, targetId, metadata) {
    // Register the edge in source's outgoing and target's incoming
    outgoingEdges.add(sourceId, targetId);
    incomingEdges.add(targetId, sourceId);
    setEdgeMetadata(sourceId, targetId, metadata);
  }
  const removeEdge = (sourceId, targetId) => {
    // Remove edge from both outgoing and incoming adjacency lists
    outgoingEdges.delete(sourceId, targetId);
    incomingEdges.delete(targetId, sourceId);

    // Remove metadata, which is only stored in the outgoing direction
    edgeMetadata.delete(sourceId, targetId);
  };
  const removeNode = (id, removeEdges = true) => {
    if (removeEdges) {
      const outgoing = outgoingEdges.get(id);
      if (outgoing) {
        for (const targetId of outgoing) {
          removeEdge(id, targetId);
        }
      }
      const incoming = incomingEdges.get(id);
      if (incoming) {
        for (const sourceId of incoming) {
          removeEdge(sourceId, id);
        }
      }
    }
    nodes.delete(id);
  };
  return {
    edge: {
      has: hasEdge,
      add: addEdge,
      remove: removeEdge,
      getOutgoing: id => outgoingEdges.get(id),
      getIncoming: id => incomingEdges.get(id),
      getAllOutgoing: () => outgoingEdges.entries(),
      getAllIncoming: () => incomingEdges.entries(),
      metadata: {
        get: getEdgeMetadata,
        set: setEdgeMetadata
      }
    },
    node: {
      get: getNode,
      set: setNode,
      has: hasNode,
      remove: removeNode,
      entries: () => nodes.entries()
    }
  };
};